import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, Typography, SxProps, useTheme } from '@mui/material';
import BulletList from '../../../components/BulletList';
import { UserContext } from '../../../context/UserContext';
import { UIContext } from '../../../context/UIContext';

interface SearchInfoProps {
    text?: SxProps;
    list?: SxProps;
    button?: SxProps;
}

const SearchInfoContent = ({ text, list, button }: SearchInfoProps) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const { locale } = useContext(UserContext);
    const { isMobile, isTablet } = useContext(UIContext);

    const textStyles: SxProps = (isMobile || isTablet) ? {fontSize: '14px', lineHeight: '143%'} : {fontSize: '10px', lineHeight: '14px'};
    const buttonStyles: SxProps = {
        letterSpacing: '0.46px',
        p: '4px 8px',
        ml: 'auto',
        mt: {
            xs: '8px',
            sm: '0px',
        },
        ...(isMobile || isTablet) ? {mx: 'auto', color: theme.palette.primary.main} : {color: theme.palette.snackbar.main}
    };

    const bulletListItems = [
        { id: 'customer', text: t('screens.transactions.fields.customer') },
        { id: 'staff', text: t('screens.transactions.fields.staff') },
        { id: 'product', text: t('screens.transactions.fields.product') },
        { id: 'miscProduct', text: t('screens.transactions.fields.miscProduct') },
        { id: 'transactionId', text: t('screens.transactions.fields.transactionId') },
        { id: 'transactionBarcode', text: t('screens.transactions.fields.transactionBarcode') },
        { id: 'productBarcode', text: t('screens.transactions.fields.productBarcode') },
        { id: 'tableName', text: t('screens.transactions.fields.tableName') },
        { id: 'ticketNumber', text: t('screens.transactions.fields.ticketNumber') },
        { id: 'transactionTotalIncTax', text: t('screens.transactions.fields.transactionTotalIncTax') },
        { id: 'totalTax', text: t('screens.transactions.fields.totalTax') },
        { id: 'individualTaxRateAmount', text: t('screens.transactions.fields.individualTaxRateAmount') },
        { id: 'totalDiscount', text: t('screens.transactions.fields.totalDiscount') },
        { id: 'sku', text: t('screens.transactions.fields.sku') },
    ];

    return (
        <Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <Typography variant="body1" sx={textStyles}>
                    {t('screens.transactions.searchInfo.youCanSearchBy')}
                </Typography>
                <BulletList items={bulletListItems} />
                <Typography variant="body1" sx={textStyles}>
                    {t('screens.transactions.searchInfo.resultsMayIncludeMatches')}
                </Typography>
            </Box>

            <Box sx={{ display: 'flex' }}>
                <Button sx={buttonStyles} component="a" href={`https://support.eposnow.com/s/article/Transaction-Report?language=${locale.substring(0, 2)}`} target="_blank" rel="noopener noreferrer">
                    {t('actions.learnMore')}
                </Button>
            </Box>
        </Box>
    );
};

export default SearchInfoContent;
